// Shown until an admin configures real testimonials via the homepage CMS
// (see HomePageContentManager) -- these are placeholder defaults only.
const defaultTestimonials = [
  {
    id: 1,
    name: 'Adaeze Okafor',
    role: 'Frontend Developer',
    course: 'Full-Stack Web Development',
    rating: 5,
    text: "LearnHub's hands-on projects gave me the confidence to land my first developer role within three months of finishing the course.",
  },
  {
    id: 2,
    name: 'Chinedu Eze',
    role: 'Data Analyst',
    course: 'Data Science Fundamentals',
    rating: 5,
    text: 'The instructors break down complex topics into bite-sized lessons. I actually looked forward to every checkpoint quiz.',
  },
  {
    id: 3,
    name: 'Fatima Bello',
    role: 'Product Designer',
    course: 'UI/UX Design Masterclass',
    rating: 4,
    text: 'Clear structure, practical assignments, and a supportive community made this the best online course I have taken.',
  },
];

export default function Testimonials({ content }) {
  const badgeText = content?.badgeText || 'Student Reviews';
  const title = content?.title || 'What Our Students Say';
  const subtitle = content?.subtitle || 'Real feedback from real learners who transformed their careers';
  const items = content?.items && content.items.length > 0 ? content.items : defaultTestimonials;

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-teal-600 text-sm font-semibold uppercase tracking-widest mb-2">{badgeText}</p>
          <h2 className="text-4xl font-bold text-slate-900">{title}</h2>
          <p className="text-slate-500 mt-2">{subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((t, idx) => (
            <div key={t.id || idx} className="bg-slate-50 rounded-2xl p-6 border border-slate-100 flex flex-col justify-between">
              <div>
                <div className="flex items-center gap-1 mb-4">
                  {[1,2,3,4,5].map(i => (
                    <div key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className={`ri-star-fill text-sm ${i <= (t.rating || 5) ? 'text-amber-400' : 'text-slate-200'}`} />
                    </div>
                  ))}
                </div>
                <p className="text-slate-600 text-sm leading-relaxed mb-5">&ldquo;{t.text}&rdquo;</p>
              </div>
              <div className="flex items-center gap-3 pt-4 border-t border-slate-200">
                <img 
                  src={t.avatar || 'https://readdy.ai/api/search-image?query=professional%20young%20Nigerian%20smiling%20African%20tech%20headshot&width=100&height=100&seq=def&orientation=squarish'} 
                  alt={t.name} 
                  className="w-10 h-10 rounded-full object-cover border border-slate-200" 
                />
                <div>
                  <p className="text-sm font-semibold text-slate-800">{t.name}</p>
                  <p className="text-xs text-slate-400">{t.role} · {t.course}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
